import WorkflowsTagSelector from './WorkflowsTagSelector';

export default WorkflowsTagSelector;
